window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.CancelOrder.init());

Sq.Shop.CancelOrder = {
  init() {
    if ($('#cancel-order-modal').length === 0) {
      return;
    }

    this.bindEvents();
  },

  bindEvents() {
    $('#cancel-order-submit').on('click', function (e) {
      e.preventDefault();
      $.ajax({
        type: 'POST',
        url: $('#cancel-order-modal').attr('data-post-url'),
      })
        .done((data) => {
          window.location = data.redirect_url;
        })
        .fail((data) => {
          window.location = data.redirect_url;
        });
    });
  },
};
